import { createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance from "../../services/axiosInstance";

// Add address api
export const addPickUpAddress = createAsyncThunk(
  "pick-up-address/addPickUpAddress",
  async (payload, { rejectWithValue }) => {
    try {
      const res = await axiosInstance.post(
        "/add-or-update-delivery-detail",
        payload,
      );
      // console.log("The res of add pick address is :", res.data);
      return res.data;
    } catch (err) {
      return rejectWithValue(err.message?.data || err.message);
    }
  },
);

export const getAddressDetails = createAsyncThunk(
  "pick-up-address/getAddressDetails",
  async (_, { rejectWithValue }) => {
    try {
      const res = await axiosInstance.get("/get-delivery-detail");
      // console.log("The delivery details is :", res.data);
      return res.data;
    } catch (err) {
      return rejectWithValue(err.message?.data || err.message);
    }
  },
);
